'use strict';

/**
 *
 * @name: nnPreviouslyInCategory
 *
 */

import DirectiveTemplate from './nn-previously-in-category.directive.html';
import './nn-previously-in-category.directive.scss';

function NnPreviouslyInCategoryDirective(
  apiCategoryService,
  apiPostService,
  transObject,
  $timeout,
  $location,
  $rootScope
) {

  'ngInject';

  return {
    replace: true,
    restrict: 'A',
    scope: {
      content: '&',
      loaded: '='
    },
    template: DirectiveTemplate,
    transclude: true,
    link: function (scope, element) {

      scope.item = scope.content();

      scope.onAnalyticsClick = () => {
        window._hmt.push(['_trackEvent', '组件', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
        $rootScope.analytics.videoAM('previously in category', scope.item.title, scope.post)
      }

      function terminate() {

        scope.$destroy();
        element.find('*').remove();
        element.remove();
      }

      if (!scope.item.jsonData.sources ||
        !scope.item.jsonData.sources[0] ||
        !scope.item.jsonData.sources[0].categoryId ||
        !scope.item.jsonData.sources[0].order ||
        !scope.item.jsonData.sources[0].order[0]) {

        return terminate();
      }

      scope.page = 1;
      scope.settings = {
        sortOrder: {
          name: 'MOST_RECENT',
          field: 'publishDate desc'
        },
        sortFields: [{
          name: 'MOST_RECENT',
          field: 'publishDate desc'
        }, {
          name: 'HIGHEST_RATED',
          field: 'lovesCount desc'
        }, {
          name: 'MOST_POPULAR',
          field: 'viewsCount desc'
        }]
      };

      scope.cat = {};

      apiCategoryService
        .getCategoryById(scope.item.jsonData.sources[0].categoryId)
        .then(function (res) {

          transObject.translate(res.data);
          scope.cat = res.data;
        });

      scope.searchCategory = function () {

        $location.search('search').search('CategoryId', scope.item.jsonData.sources[0].categoryId);
      };

      var month = null;
      var newDate = null;
      scope.itemList = [];
      scope.monthIndexList = [];

      function getPosts(callback) {

        scope.page = 1;
        scope.monthIndexList = [];

        apiPostService
          .getPost(scope.item.jsonData.sources[0].categoryId, scope.settings.sortOrder.field, scope.page, 8, false, false, true, false, false, false, false, false, false, true)
          .then(function (res) {

            scope.metaTotalPages = res.data.meta.totalPages;

            res.data.items.forEach(function (item, index) {

              transObject.translate(item);
              transObject.calendarDate(item);
              transObject.setBookmark(item);
              transObject.getDuration(item);
              transObject.trueSlug(item);

              if (moment(item.publishDate).format('MM') !== month) {

                month = moment(item.publishDate).format('MM');
                if (index !== 0 || scope.page !== 1) {

                  newDate = moment(item.publishDate);
                  scope.monthIndexList.push({
                    index: index + scope.monthIndexList.length,
                    date: newDate,
                    publishDate: item.publishDate
                  });
                }
              }
            });

            callback(res.data.items);
            scope.itemList = res.data.items;
            $timeout(function () {

              echo.render();
            }, 50);
          });
      }

      scope.loadMore = function () {
        window._hmt.push(['_trackEvent', '类目列表-组件-查看更多', 'click', `parentType=${scope.item.parentType},index=${scope.item.index},moduleId=${scope.item.id},parentSlug=${scope.item.parentSlug || ''}`]);
        scope.page++;
        scope.monthIndexList = [];

        apiPostService
          .getPost(scope.item.jsonData.sources[0].categoryId, scope.settings.sortOrder.field, scope.page, 8, false, false, true, false, false, false, false, false, false, true)
          .then(function (res) {

            res.data.items.forEach(function (item, index) {

              transObject.translate(item);
              transObject.calendarDate(item);
              transObject.setBookmark(item);
              transObject.getDuration(item);
              transObject.trueSlug(item);

              if (moment(item.publishDate).format('MM') !== month) {

                month = moment(item.publishDate).format('MM');
                if (index !== 0 || scope.page !== 1) {

                  newDate = moment(item.publishDate);
                  scope.monthIndexList.push({
                    index: index + scope.monthIndexList.length,
                    date: newDate,
                    publishDate: item.publishDate
                  });
                }
              }
            });

            addMonthCards(res.data.items);
            scope.itemList = scope.itemList.concat(res.data.items);
          });
      };

      function addMonthCards(resultArray) {

        scope.monthIndexList.forEach(function (item) {

          resultArray.splice(item.index, 0, {
            publishDate: item.publishDate,
            monthCard: true,
            month: item.date.format('MMMM'),
            year: item.date.format('YYYY')
          });
        });
        scope.loaded = true;
      }

      getPosts(addMonthCards);

      var firstTime = true;
      scope.$watch('settings', function () {

        if (!firstTime) {

          getPosts(addMonthCards);
        }
        firstTime = false;
      }, true);
    }
  };
}

export default NnPreviouslyInCategoryDirective;



// WEBPACK FOOTER //
// ./app/pages/category/nn-previously-in-category/nn-previously-in-category.directive.js